import * as Preact from "preact"
import Index from "@frog/source/models/App.js"
import Navigation from "@frog/source/models/Navigation.js"
import Keyset from "@frog/source/utility/Keyset.js"
import manifest from "@frog/source/manifest.js"

import "@frog/source/views/app/screens/CreditsScreen.view.less"

import Logo from "@frog/source/images/ld47/logo.png"

export default class CreditsScreen {
    render() {
        return (
            <div class="CreditsScreen">
                <div class="Background"/>
                <div class="Sections">
                    <section class="VictoryStatus">
                        <div class="Prompt">
                            You escaped!!
                        </div>
                        <div class="Units">
                            <div class="Unit" isActive={this.isUnitActive("pusher")}>
                                <img class="Sprite" src={require("@frog/source/images/ld47/ludumDare47_characterUnit1.png").default}/>
                            </div>
                            <div class="Unit" isActive={this.isUnitActive("puller")}>
                                <img class="Sprite" src={require("@frog/source/images/ld47/ludumDare47_characterUnit2.png").default}/>
                            </div>
                            <div class="Unit" isActive={this.isUnitActive("flipper")}>
                                <img class="Sprite" src={require("@frog/source/images/ld47/ludumDare47_characterUnit3.png").default}/>
                            </div>
                            <div class="Unit" isActive={this.isUnitActive("aoe-er")}>
                                <img class="Sprite" src={require("@frog/source/images/ld47/ludumDare47_characterUnit4.png").default}/>
                            </div>
                        </div>
                    </section>
                    <section class="Title">
                        <img class="Logo" src={Logo}/>
                    </section>
                    <section class="Team">
                        <div class="Group">
                            <div class="Member">
                                <img class="Sprite" src={require("@frog/source/images/ld47/ludumDare47_characterUnit1.png").default}/>
                                <div class="Details">
                                    <div class="Name">Andrew Goodenough</div>
                                    <div class="Role">Producer & Programmer</div>
                                    <div class="social">@ehgoodenough</div>
                                </div>
                            </div>
                        </div>
                        <div class="Group">
                            <div class="Member">
                                <img class="Sprite" src={require("@frog/source/images/ld47/ludumDare47_characterUnit4.png").default}/>
                                <div class="Details">
                                    <div class="Name">Lil Chan</div>
                                    <div class="Role">Character Designer</div>
                                    <div class="social">@lalalichan</div>
                                </div>
                            </div>
                            <div class="Member">
                                <img class="Sprite" src={require("@frog/source/images/ld47/ludumDare47_characterUnit2.png").default}/>
                                <div class="Details">
                                    <div class="Name">Lisa Asenbrenner</div>
                                    <div class="Role">Environment Artist</div>
                                    <div class="social">@gamedev_bunny</div>
                                </div>
                            </div>
                        </div>
                        <div class="Group">
                            <div class="Member">
                                <img class="Sprite" src={require("@frog/source/images/ld47/ludumDare47_characterUnit3.png").default}/>
                                <div class="Details">
                                    <div class="Name">don’tblinkoryou’lldie</div>
                                    <div class="Role">Music & SFX Composer</div>
                                    <div class="social">@dboydchipmusic</div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section class="SpecialThanks">
                        <div class="Header">
                            Special Thanks!
                        </div>
                        <div class="Name">David McPherson</div>
                        <div class="Name">Alex Asenbrenner</div>
                        <div class="Name">Colin Vandervort</div>
                        <div class="Name">Steve Zapata</div>
                        <div class="Name">César Garza</div>
                        <div class="Name">Brad Kraeling</div>
                        <div class="Name">Kieran Lampert</div>
                        <div class="Name">Rachael Owens</div>
                        <div class="Name">Susan Karther</div>
                        <div class="Name">The EOTS team</div>
                        <div class="Name">Oliver the Cat</div>
                        <div class="Name">Alma the Cat</div>
                        <div class="Name">Max the Dog</div>
                        <div class="Name">Omri Perez</div>
                        <div class="Name">Nick Amlag</div>
                        <div class="Name">Ed Lu</div>
                    </section>
                    <section class="Thanks">
                        Thanks for playing!!!
                    </section>
                </div>
            </div>
        )
    }
    isUnitActive(unitSlug) {
        // if(unitSlug == "puller") return false
        // if(unitSlug == "flipper") return false
        if(Index.game == undefined || Index.game.encounter == undefined) return true
        const unit = Keyset.find(Index.game.encounter.stage.units, (unit) => unit.reference == unitSlug)
        if(unit == undefined) return false
        if(unit.hasEscaped == true) return true
        return false
    }
}
